import type { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

export type MetricTooltipContentProps = {
  description: string;
  example: string;
  note?: string;
  maxW?: string;
};

export const MetricTooltipContent: FC<MetricTooltipContentProps> = ({
  description,
  example,
  note,
  maxW = '320px',
}) => (
  <Box maxW={maxW}>
    <Text fontSize="sm" color="text.primary">
      {description}
    </Text>
    <Text mt={3} fontSize="sm" fontWeight="semibold" color="text.primary">
      Example:
    </Text>
    <Text fontSize="sm" color="text.primary">
      {example}
    </Text>
    {note && (
      <>
        <Text mt={3} fontSize="sm" fontWeight="semibold" color="text.primary">
          Note:
        </Text>
        <Text fontSize="sm" color="text.primary">
          {note}
        </Text>
      </>
    )}
  </Box>
);
